import Cookies from 'js-cookie';

const closeBanner = (container) => {
  const innerContainer = container.querySelector('.m-alert-banner__inner');
  const button = container.querySelector('.close-button');
  const cookieTitle = container.dataset.slug;

  innerContainer.style.opacity = '0';
  button.style.opacity = '0';
  container.classList.add('disappearing');
  Cookies.set(cookieTitle, 'true', { expires: 30 });

  container.addEventListener('transitionend', (event) => {
    if (event.target === container && event.propertyName === 'height') {
      container.style.display = 'none';
    }
  });

  // Collapse the banner after fading out the content.
  setTimeout(() => {
    container.style.height = `${container.offsetHeight}px`;

    requestAnimationFrame(() => {
      container.style.height = '0px';
      container.style.paddingTop = '0px';
      container.style.paddingBottom = '0px';
    });
  }, 300);
};

const handleCloseClick = (event) => {
  const container = event.target.closest('.m-alert-banner');
  closeBanner(container);
};

const handleLinkClick = (event) => {
  const link = event.currentTarget;
  // Only dismiss for links back into the site; external links leave the banner state untouched.
  if (link.hostname === window.location.hostname) {
    closeBanner(link.closest('.m-alert-banner'));
  }
};

export const initializeAlert = () => {
  const navbar = document.getElementById('navbar');

  function resize() {
    if (window.innerWidth < 1090) {
      navbar.classList.add('navbar-alert-height');
    } else {
      navbar.classList.remove('navbar-alert-height');
    }
  }

  window.addEventListener('resize', resize);
  const elements = document.getElementsByClassName('m-alert-banner');
  Array.from(elements).forEach((element) => {
    // An inline script already hides it synchronously if closed; this only needs to skip binding a listener.
    if (Cookies.get(element.dataset.slug) === 'true') {
      return;
    }

    const button = element.querySelector('.close-button');
    button.addEventListener('click', handleCloseClick);

    const link = element.querySelector('.m-alert-banner__inner a');
    if (link) {
      link.addEventListener('click', handleLinkClick);
    }
  });
};
